export default __webpack_public_path__ + "static/media/search-icon.fee2e41d.svg";